import React from "react";

const Fotter = () => {
  return (
    <>
      <footer className="footer">
        <h3>
          Dante Iturri <i className="fa fa-copyright" aria-hidden="true"></i>
        </h3>
      </footer>
    </>
  );
};

export default Fotter;
